module.exports = __webpack_public_path__ + "img/c_10.4bf6e793.png";